import { render } from "./CustomPage.vue?vue&type=template&id=63d884a9&scoped=true&ts=true"
import script from "./CustomPage.vue?vue&type=script&lang=ts"
export * from "./CustomPage.vue?vue&type=script&lang=ts"

import "./CustomPage.vue?vue&type=style&index=0&id=63d884a9&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63d884a9"]])

export default __exports__